import Link from 'gatsby-link';
import React from 'react';

import ArticleListing from '../components/article-listing.js';
import EventListing from '../components/event-listing.js';

export default ({ data, pathContext }) => {
  let articles = [], events = [];

  if(data.allArticlesYaml) {
    articles = data.allArticlesYaml.edges.map(edge => edge.node)
  }

  if(data.allEventsYaml) {
    events = data.allEventsYaml.edges.map(edge => edge.node)
  }

  return(
    <div>
      <div className="breadcrumb">
        <Link to="/">
          Home
        </Link>
        <span> › </span>
        Tag: {pathContext.tag}
      </div>

      <div className="title">
        Tag: {pathContext.tag}
      </div>

      <EventListing events={events} />
      <ArticleListing articles={articles} />
    </div>
  );
};

export const query = graphql`
  query Tag($tag: String!) {
    allArticlesYaml(filter: { tags: { in: [$tag] } }) {
      edges {
        node {
          ...ArticleListingFields
        }
      }
    }
    allEventsYaml(filter: { tags: { in: [$tag] } }) {
      edges {
        node {
          ...EventListingFields
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/tag.js